import React, { ReactNode } from 'react';

export const RightCard: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className="lg:p-8">
      <div className="mx-auto flex w-[90vw] max-w-[90vw]  flex-col justify-center space-y-6 sm:w-96 sm:max-w-sm">
        {children}
      </div>
    </div>
  );
};
